import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { formatDate, shortenedDate } from 'Consts/DateFormats';
import LinkStatusIndicatorIconPicker from './LinkStatusIndicatorIconPicker';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
  },
  icon: {},
  date: {
    marginLeft: theme.spacing(0.5),
  },
});

const LinkStatusIndicator = ({
  className,
  classes,
  lastUpdated,
  linkStatus,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <LinkStatusIndicatorIconPicker
        className={classes.icon}
        linkStatus={linkStatus}
      />
      {lastUpdated.length > 0 ? (
        <Typography
          className={classes.date}
          variant={'body1'}
          color={'black'}
          component={'span'}
          test={'balance-sheet-account-link-status'}
        >
          {formatDate(lastUpdated, shortenedDate)}
        </Typography>
      ) : null }
    </Box>
  );
};

LinkStatusIndicator.defaultProps = {
  className: '',
};

LinkStatusIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  linkStatus: PropTypes.string.isRequired,
};

export default withStyles(styles)(LinkStatusIndicator);
